import { Controller } from "@hotwired/stimulus"
import PdfViewer from "../components/pdf/PdfViewer.svelte"
import { mount, unmount } from "svelte"

export default class extends Controller {
  static values = {
    url: String,
  }

  connect() {
    // Mount lazily on first visibility so a viewer that is hidden (a closed
    // fullscreen dialog, the mobile-hidden inline box) never fetches — and
    // never triggers a server-side stamp — until it is actually shown.
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.observer.disconnect()
        this.observer = null
        this.viewer = mount(PdfViewer, {
          props: { url: this.urlValue },
          target: this.element,
        })
      }
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.viewer) unmount(this.viewer)
  }
}
